var React = require('react');

function Play (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M2.64227 0.840813C2.884 0.70963 3.17814 0.721279 3.40874 0.871168L13.4087 7.37117C13.6216 7.50952 13.75 7.74614 13.75 8C13.75 8.25386 13.6216 8.49048 13.4087 8.62883L3.40874 15.1288C3.17814 15.2787 2.884 15.2904 2.64227 15.1592C2.40054 15.028 2.25 14.775 2.25 14.5V1.5C2.25 1.22497 2.40054 0.971997 2.64227 0.840813ZM3.75 2.88202V13.118L11.6238 8L3.75 2.88202Z","fill":"#181818"}));
}

Play.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = Play;

Play.default = Play;
